import { jsx as C, jsxs as se } from "react/jsx-runtime";
import ue from "classnames";
import { noop as ae } from "lodash/fp";
import { useRef as b, useState as z, useMemo as J, useCallback as s, useEffect as ce } from "react";
import E from "./index.es2495.js";
import { onKeyDownEnterAndSpace as Q } from "./index.es526.js";
import { onKeyDownArrows as de } from "./index.es527.js";
import { onKeyDownTab as X } from "./index.es529.js";
import { BasicMenuItem as fe, BASIC_MENU_ITEM_HEIGHT as Y } from "./index.es83.js";
import { UtilityChevronIcon as ie } from "./index.es439.js";
import { MenuListContainer as Z } from "./index.es88.js";
const me = ({
  items: l,
  setItems: A,
  testId: N = "cascading-menu",
  maxVisibleItems: H,
  onItemSelection: y = ae,
  subMenuOpeningLogicBy: F = "hover",
  menuWidth: R,
  autoFocus: I = !1
}) => {
  var P;
  const B = b(null), S = b(null), O = b(null), T = b(null), x = b(null), k = b(null), [d, M] = z(""), [g, i] = z(!1), m = F === "click", V = ue(E.menuList, {
    [E.subMenuOpen]: d !== ""
  }), h = J(
    () => {
      var e, n;
      return ((e = l.find(({ value: r }) => r === d)) == null ? void 0 : e.subItems) || ((n = l.find(({ subItems: r }) => r == null ? void 0 : r.some(({ isSelected: t }) => t))) == null ? void 0 : n.subItems) || [];
    },
    [d, l]
  ), v = s(
    (e, n, r, t, u = 50) => {
      var o;
      (o = e.current) == null || o.scrollToItem(r, "smart"), setTimeout(() => {
        var a;
        const c = (a = n.current) == null ? void 0 : a.querySelector(
          `[data-value="${t[r].value}"]`
        );
        c == null || c.focus(), i(!0);
      }, u);
    },
    []
  ), f = s(
    (e) => {
      A(
        l.map((n) => {
          if (n.value === e.value)
            return { ...n, isSelected: !0 };
          if (n.subItems) {
            const r = n.subItems.map(
              (t) => t.value === e.value ? { ...t, isSelected: !0 } : { ...t, isSelected: !1 }
            );
            return { ...n, subItems: r, isSelected: !1 };
          }
          return { ...n, isSelected: !1 };
        })
      );
    },
    [l, A]
  ), _ = s(
    (e, n) => {
      var r, t;
      if (!e.isDisabled) {
        if (!((r = e.subItems) != null && r.length)) {
          f(e), y(e);
          return;
        }
        (t = n == null ? void 0 : n.stopPropagation) == null || t.call(n), e.value === d ? M("") : (f(e), M(e.value));
      }
    },
    [d, f, y]
  ), L = s(
    (e) => {
      e.isDisabled || (i(!0), e.value === d ? M("") : (f(e), M(e.value), setTimeout(() => {
        var n;
        (n = k.current) == null || n.scrollToItem(0, "smart"), setTimeout(() => {
          var t;
          const r = (t = T.current) == null ? void 0 : t.querySelector(
            '[role="menuitem"]'
          );
          r == null || r.focus();
        }, 20);
      }, 20)));
    },
    [d, f]
  ), $ = s(
    (e) => {
      !m && !g && !e.isDisabled && M(e.value);
    },
    [m, g]
  ), W = J(() => ({
    "--cascading-menu-width": R + "px"
  }), [R]), ee = s(() => {
    !m && !g && M("");
  }, [m, g]), ne = s(() => {
    g && i(!1);
  }, [g]), j = s(
    (e, n) => {
      i(!1), _(n, e);
    },
    [_]
  ), q = s(
    (e) => {
      $(e);
    },
    [$]
  ), D = s(
    (e, n, r, t, u, o) => {
      i(!0), o != null && o.enter && Q(e, o.enter, !0), de(
        e,
        {
          right: o == null ? void 0 : o.right,
          left: o == null ? void 0 : o.left,
          up: () => {
            const c = r.findIndex(
              ({ value: p }) => p === n.value
            ), a = Math.max(0, c - 1);
            v(t, u, a, r);
          },
          down: () => {
            const c = r.findIndex(
              ({ value: p }) => p === n.value
            ), a = Math.min(r.length - 1, c + 1);
            v(t, u, a, r);
          }
        },
        !0
      ), o != null && o.enter && X(
        e,
        () => {
          const c = r.findIndex(
            ({ value: p }) => p === n.value
          ), a = Math.min(r.length - 1, c + 1);
          v(t, u, a, r);
        },
        !0
      );
    },
    [v]
  ), U = s(
    (e, n) => {
      i(!0), Q(
        e,
        () => {
          var r;
          (r = n.subItems) != null && r.length ? n.isDisabled || L(n) : (f(n), y(n));
        },
        !0
      ), D(e, n, l, x, S, {
        right: () => {
          var r;
          (r = n.subItems) != null && r.length && !n.isDisabled && L(n);
        }
      }), X(
        e,
        () => {
          const r = l.findIndex(({ value: u }) => u === n.value), t = Math.min(l.length - 1, r + 1);
          v(x, S, t, l);
        },
        !0
      );
    },
    [
      L,
      l,
      D,
      v,
      f,
      y
    ]
  ), w = s(
    (e) => {
      i(!1), y(e), f(e);
    },
    [y, f]
  ), G = s(
    (e, n) => {
      i(!0), D(e, n, h, k, T, {
        left: () => {
          M("");
          const r = l.find(
            (t) => {
              var u;
              return t.value === d || ((u = t.subItems) == null ? void 0 : u.some((o) => o.value === n.value));
            }
          );
          if (r) {
            const t = l.findIndex((u) => u.value === r.value);
            v(x, S, t, l);
          }
        },
        enter: () => w(n)
      });
    },
    [
      h,
      d,
      w,
      l,
      D,
      v
    ]
  );
  ce(() => {
    var e;
    I && ((e = O.current) == null || e.focus());
  }, [I]);
  const K = s(
    ({
      item: e,
      index: n,
      itemsList: r,
      onClick: t,
      onMouseEnter: u,
      onKeyDown: o,
      style: c
    }) => {
      const { subItems: a, ...p } = e, oe = "isSelected" in e ? e.isSelected || ((a == null ? void 0 : a.some(({ isSelected: le }) => le)) ?? !1) : !1;
      return /* @__PURE__ */ C(
        fe,
        {
          ...p,
          "data-value": e.value,
          wrapperStyle: c,
          onClick: t,
          onMouseEnter: u,
          onKeyDown: o,
          isSelected: oe,
          ref: I && n === 0 ? O : void 0,
          hasDivider: n < r.length - 1,
          RightComponent: a ? /* @__PURE__ */ C(ie, { direction: "left" }) : p.RightComponent
        }
      );
    },
    [I]
  ), re = s(
    ({ index: e, style: n }) => {
      const r = l[e];
      return K({
        item: r,
        index: e,
        itemsList: l,
        onClick: (t) => j(t, r),
        onMouseEnter: () => q(r),
        onKeyDown: (t) => U(t, r),
        style: n
      });
    },
    [l, j, q, U, K]
  ), te = s(
    ({ index: e, style: n }) => {
      const r = h[e];
      return K({
        item: r,
        index: e,
        itemsList: h,
        onClick: () => w(r),
        onKeyDown: (t) => G(t, r),
        style: n
      });
    },
    [h, w, G, K]
  );
  return /* @__PURE__ */ se(
    "div",
    {
      ref: B,
      "data-testid": N,
      className: E.root,
      style: W,
      onMouseLeave: ee,
      onMouseMove: ne,
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: V,
            ref: S,
            "data-testid": `${N}-main-menu`,
            children: /* @__PURE__ */ C(
              Z,
              {
                ref: x,
                itemHeight: Y,
                itemCount: l.length,
                maxVisibleItems: H,
                children: re
              }
            )
          }
        ),
        h.length > 0 && /* @__PURE__ */ C(
          "div",
          {
            className: E.subMenu,
            style: { height: (P = B.current) == null ? void 0 : P.clientHeight },
            ref: T,
            "data-testid": `${N}-sub-menu`,
            "data-is-open": !!h.length,
            children: /* @__PURE__ */ C(
              Z,
              {
                ref: k,
                itemHeight: Y,
                itemCount: h.length,
                maxVisibleItems: H,
                children: te
              }
            )
          }
        )
      ]
    }
  );
};
export {
  me as CascadingMenu
};
//# sourceMappingURL=index.es81.js.map
